import { useContext } from 'react';
import jsCookie from 'js-cookie';
import { keys } from 'lodash';
import { CookieContext } from '../../components/providers';
export var CookieMatcher = {
    prod: /\bskillshare_user_\b/,
    qa: /\bqa_skillshare_user_\b/,
};
export function useCookies() {
    var _a = useContext(CookieContext), cookies = _a.cookies, rawCookie = _a.rawCookie;
    var hasCookie = function (key) {
        return !!(cookies && keys(cookies).find(function (k) { return !!k.match(key); }));
    };
    var setCookie = function (_a) {
        var key = _a.key, value = _a.value, options = _a.options;
        if (!cookies) {
            return;
        }
        cookies[key] = value;
        jsCookie.set(key, value, options);
    };
    return {
        cookies: cookies,
        rawCookie: rawCookie,
        hasCookie: hasCookie,
        setCookie: setCookie,
    };
}
//# sourceMappingURL=use-cookies.js.map